<style scoped>
.property-list-title {
  font-size: large;
}
</style>

<template>
  <div>
    <b-row>
      <b-col :md="12" :offset-md="12">
        <vue-form-generator
          ref="searchPropForm"
          :schema="schema"
          :model="model"
          :options="formOptions"
          @keyup.enter.native="search"
        />
      </b-col>
    </b-row>
    <b-row v-if="model.apnOrAddress === 'address'">
      <b-col>
        <address-form-fields
          ref="propertyAddressForm"
          :grid="grid"
          :removeStates="statesToRemove"
          :form="model.address"
          @address-updated="model.address = $event"
          @keyup.enter.native="search"
        />
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col class="text-right">
        <b-button class="btn-anchor raised" id="btn-search-property" @click="search">
          <font-awesome-icon icon="search"/>
          {{ hasSelectedProperties ? 'Search Again' : 'Search' }}
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="searched && properties.length == 0">
      <b-col>
        <hr/>
        <b-card text-variant="danger" border-variant="danger" class="text-center">
          <font-awesome-icon icon="exclamation-triangle"/>
          <strong>No Properties found.</strong>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="properties.length > 0">
      <b-col style="max-height: 400px; overflow: scroll" class="mb-2">
        <hr/>
        <b-row class="mb-3">
          <b-col class="text-center">
            <div class="property-list-title">Properties Found</div>
          </b-col>
        </b-row>
        <b-row
          v-for="(property, index) in properties"
          :key="`${property.apn}-${property.address}`"
          class="mb-3"
        >
          <b-col>
            <b-card no-body @click="$emit('property-clicked', property, index)"
                    class="property-card pointer-cursor"
                    :text-variant="selectedApnList.includes(property.apn) ? 'light' : 'dark'"
                    :bg-variant="selectedApnList.includes(property.apn) ? 'dark' : 'light'"
            >
              <cross-display
                :cross="property"
              />
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-3" v-if="displayCloseButton">
      <b-col class="text-right">
        <b-button
          variant="dark"
          class="raised"
          id="search-property-btn-done"
          @click="$emit('close-search')"
        >
          Done
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import helper from '@/libs/helper';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

import VueFormGenerator from 'vue-form-generator';
import AddressFormFields from '@/components/utils/address/AddressFormFields';
import CrossDisplay from '@/components/utils/properties/CrossDisplay';

import noLendStates from '@/components/utils/address/resources/noLendStates.json';
import PROPERTY_SEARCH_MODEL from '@/components/utils/properties/resources/model.json';
import PROPERTY_SEARCH_SCHEMA from '@/components/utils/properties/schemas/search';


library.add(faSearch, faExclamationTriangle);

export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
    CrossDisplay,
    AddressFormFields,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    selectedApnList: {
      type: Array,
      required: true,
    },
    showDone: {
      type: Boolean,
      default: false,
    },
    hasSelectedProperties: Boolean,
  },
  data() {
    return {
      searched: false,
      properties: [],
      model: this.getModel('address'),
      schema: PROPERTY_SEARCH_SCHEMA.schema(this.setModel),
      formOptions: PROPERTY_SEARCH_SCHEMA.options,
      statesToRemove: noLendStates,
      grid: {
        lg: { cols: 12, offset: 0 },
        md: { cols: 12, offset: 0 },
      },
    };
  },
  computed: {
    displayCloseButton() {
      return this.properties.some(prop => this.isSelected(prop)) && this.showDone;
    },
  },
  methods: {
    isSelected(property) {
      return this.selectedApnList.indexOf(property.apn) > -1;
    },
    setModel(model, newVal) {
      this.model = this.getModel(newVal);
    },
    getModel(option) {
      const model = helper.copy(PROPERTY_SEARCH_MODEL);
      model.apnOrAddress = option;
      return model;
    },
    search() {
      const isApnSearch = this.model.apnOrAddress === 'apn';
      const formValid = isApnSearch ?
        this.$refs.searchPropForm.validate() :
        this.$refs.propertyAddressForm.validate();
      if (!formValid) {
        return;
      }


      const data = isApnSearch ?
        { apn: this.model.apn } :
        { address: this.model.address };
      const url = `/search_property?q=${JSON.stringify(data)}`;
      this.$root.$reqs.get(url)
        .then((response) => {
          this.searched = true;
          this.properties = response.data.data;
          this.$emit('properties-found', this.properties);
        })
        .catch(() => {
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/properties/SearchPropertyForm.vue